module.exports =
  '_BASIC_ANALYSIS':
    'MY_AVG_TOTAL_SHOT': 'Average Score'
    'MY_AVG_PUTT': 'Avg. Putts'
    'PER_ONE_HOLE': 'Per 1 Hole'
    'MY_GOAL': 'Goal'
    'ALL_MEMBERS_TOP': 'All User\'s'
    'ALL_MEMBERS_BELLOW': ''
    'FAIRWAY_HIT': 'Fairway hit'
    'RAT_PAR_ON': 'GIR (%)'
    'RAT_BOGEY_ON': 'GIR+1 (%)'
    'THIS_YEAR': 'Current year'
    'LAST_3_MONTHS': 'Last 3 months'
    'LAST_6_MONTHS': 'Last 6 months'
    'ENTIRE_PERIOD': 'Entire period'

  '_SCORE_ANALYSIS':
    'TITLE': 'Score Analysis'
    'EAGLE': 'Eagle or under'
    'BIRDIE': 'Birdie'
    'PAR': 'Par'
    'BOGEY': 'Bogey'
    'DBOGEY': 'Double Bogey'
    'TRIPLE_BOGEY_OVER': 'Triple Bogey or Over'

  '_STROKE_ANALYSIS':
    'TITLE':'Stroke Analysis'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/i18n/en.coffee